<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <textarea
            :value="value"
            class="wf-input wf-textarea"
            :class="{ 'wf-input--error': error }"
            :placeholder="label"
            rows="4"
            @input="emitValue($event.target.value)"
        ></textarea>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'

export default {
    name: 'TextareaField',
    mixins: [FieldMixin]
}
</script>
